import { Injectable } from '@angular/core'
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MessageService } from '../../../shared/services/common/message.service';

@Injectable()
export class FormFieldsValidator {
    constructor(private messages: MessageService) {
    }

    validate(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control) control.markAsTouched({ onlySelf: true });
        });

        if (!formGroup.valid) {
            this.messages.showCorrectAllValidationErrorsMsg();
            return false;
        }

        return true;
    }
}